import { createModelSegment } from 'client/data/luckdragon/segment';
import { EdmundsAPI } from 'client/data/api/api-client';
import { get } from 'lodash';
import { getExperimentState } from 'client/data/utils/state';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import { VisitorModel } from './visitor';
import { PageModel } from './page';
import { UserAgentModel } from './user-agent';

export function buildMakeModelActionsPath({ make, model, actionSpaceId }) {
  return `actionSpaceIds["${actionSpaceId}"].makes["${make}"].models["${model}"].actions`;
}
export function buildMakeModelParamsPath({ make, model, actionSpaceId }) {
  return `actionSpaceIds["${actionSpaceId}"].makes["${make}"].models["${model}"].params`;
}

export const PredictionsModel = createModelSegment('predictions', [
  /**
   * @see buildMakeModelParamsPath
   */
  {
    path: 'actionSpaceIds["core-6824-personal-cta-ax"].makes["{make}"].models["{model}"].params',
  },
  /**
   * @see buildMakeModelActionsPath
   */
  {
    path: 'actionSpaceIds["{actionSpaceId}"].makes["{make}"].models["{model}"].actions',
    async resolve({ actionSpaceId, make, model }, context) {
      const experimentsState = await getExperimentState(context);

      const { dimensions } = ExperimentUtil.getForcedOrAssignedAxRecipe({
        state: experimentsState,
        campaignName: actionSpaceId,
      });

      if (get(dimensions, 'action') || get(dimensions, 'eop_should_check') !== 'true') {
        return Promise.resolve(null);
      }

      const [visitorId, sessionId, sessionEntryParams, pageName, userAgent, zipCode, referer, additionalParams] =
        await Promise.all([
          context.resolveValue('id', VisitorModel),
          context.resolveValue('session', VisitorModel),
          context.resolveValue('sessionEntryParams', VisitorModel),
          context.resolveValue('page.name', PageModel),
          context.resolveValue('userAgent', UserAgentModel),
          context.resolveValue('location.zipCode', VisitorModel),
          context.resolveValue('page.referer', PageModel),
          context.resolveValue(buildMakeModelParamsPath({ actionSpaceId, make, model })),
        ]);

      return EdmundsAPI.fetchJson(`/hydro/v1/predict/${actionSpaceId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          visitor_id: visitorId,
          session_id: sessionId,
          page_load_timestamp: Date.now(),
          referring_url: referer || '',
          entry_url_info: sessionEntryParams,
          user_agent: userAgent,
          page_name: pageName,
          zip_code: zipCode,
          make,
          model,
          ...additionalParams,
        }),
      })
        .then(response => get(response, 'content.action', null))
        .catch(() => null);
    },
  },
]);
